import React from 'react';
import { ApolloProvider, gql, useQuery } from '@apollo/client';
import client from '../lib/apolloClient';
import PartnerDashboard from '../components/Succeedo/PartnerWorkspace/PartnerDashboard';

const PARTNER_DASHBOARD_QUERY = gql`
  query PartnerDashboard {
    currentUser {
      id
      name
      succeedo_persona
      action_plan {
        open_count(source: "succeedo")
        completed_count(source: "succeedo")
      }
    }
    partner_leads
  }
`;

function deriveInitials(name) {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  const first = parts[0] ? parts[0][0] : '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
}

function PartnerDashboardLoader() {
  const { data, loading } = useQuery(PARTNER_DASHBOARD_QUERY);

  const user = data?.currentUser;
  const persona = (user?.succeedo_persona || 'seller').toUpperCase();
  const userName = user?.name || '';
  const userInitials = deriveInitials(userName);

  const actionPlan = user?.action_plan || {};
  const openCount = actionPlan.open_count || 0;
  const completedCount = actionPlan.completed_count || 0;
  const total = Math.max(openCount + completedCount, 5);
  const planProgress = {
    completed: completedCount,
    total,
    percentage: total > 0 ? Math.round((completedCount / total) * 100) : 0,
  };

  return (
    <PartnerDashboard
      leads={data?.partner_leads || []}
      loading={loading}
      persona={persona}
      userName={userName}
      userInitials={userInitials}
      planProgress={planProgress}
      actionPlanBadge={openCount}
      isPartner
    />
  );
}

const SucceedoPartnerDashboardContainer = (_props, _railsContext) => (
  <ApolloProvider client={client}>
    <PartnerDashboardLoader />
  </ApolloProvider>
);

export default SucceedoPartnerDashboardContainer;
